import ColumnsComponent from './Columns.vue';
export const Columns = ColumnsComponent;
export default Columns;
